import { FixaSkeleton } from "../../../shared/wrappers/FixaSkeleton/FixaSkeleton";
import TaskDetailSkeleton from "./TaskDetailSkeleton.module.css";

export const TaskWidgetSkeleton = () => (
  <>
    <FixaSkeleton
      width="calc(100% - 56px)"
      height="266px"
      className={TaskDetailSkeleton["task-details-skeleton"] ?? ""}
    />
    <FixaSkeleton
      width="calc(100% - 56px)"
      height="95px"
      className={TaskDetailSkeleton["task-details-skeleton"] ?? ""}
    />
    <FixaSkeleton
      width="calc(100% - 56px)"
      height="95px"
      className={TaskDetailSkeleton["task-details-skeleton"] ?? ""}
    />
    <FixaSkeleton
      width="calc(100% - 56px)"
      height="95px"
      className={TaskDetailSkeleton["task-details-skeleton"] ?? ""}
    />
    <FixaSkeleton
      width="calc(100% - 56px)"
      height="95px"
      className={TaskDetailSkeleton["task-details-skeleton"] ?? ""}
    />
    <FixaSkeleton
      width="calc(100% - 56px)"
      height="95px"
      className={TaskDetailSkeleton["task-details-skeleton"] ?? ""}
    />
  </>
);
